import { isPartRejected } from '../helpers/pollRework';
import { TSinglePollDetails } from '../types/pollsSchema';

export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // Обмен элементов
  }
  return array;
}

export const mappedSingleTestData = (data: TSinglePollDetails) => {
  const sourceImages = Array.isArray(data.images) ? data.images : [];
  const resultImages = data.images_show_random
    ? shuffleArray([...sourceImages])
    : [...sourceImages];
  return {
    ...data,
    images: resultImages.map(item => ({
      ...item,
      isBlurred:
        data.type === 'click' ||
        data.media_type === 'text' ||
        sourceImages[0]?.type === 'text' ||
        isPartRejected(data)
          ? false
          : true,
      isAdultOnly: data.adult_only,
    })),
  };
};
